<div class="upload-file-list" *ngIf="files?.length">
  <ng-container *ngFor="let file of files; let i = index">
    <div *ngIf="file?.name" class="upload-file-row" [class.is-uploading]="isUploading(file)">

      <i class="material-icons upload-file-icon">description</i>

      <span class="upload-file-name" (click)="openFile.emit(file)" [title]="file.name">{{ file.name }}</span>

      <span class="upload-file-size" *ngIf="!isUploading(file)">{{ readableFileSize(file.size) }}</span>

      <div class="upload-file-trailing">
        <ng-container *ngIf="isUploading(file); else storedFile">
          <mat-progress-bar class="upload-file-progress"
                            mode="determinate"
                            color="primary"
                            [value]="file.progress"></mat-progress-bar>
          <span class="upload-file-status">Uploading...</span>
          <i *ngIf="removable"
             class="material-icons upload-file-action"
             matTooltip="Cancel upload"
             (click)="removeFile.emit(i)">close</i>
        </ng-container>

        <ng-template #storedFile>
          <i *ngIf="removable"
             class="material-icons upload-file-action upload-file-remove"
             matTooltip="Remove file"
             (click)="removeFile.emit(i)">delete</i>
        </ng-template>
      </div>
    </div>
  </ng-container>
</div>
